module.exports = __webpack_public_path__ + "media/audio62.a14bc8fe.mp3";